import api from "./api";

export async function listDepoimentos() {
  const { data } = await api.get("/Depoimentos");
  return data;
}

export async function createDepoimento(payload) {
  const { data } = await api.post("/Depoimentos", payload);
  return data;
}

export async function updateDepoimento(id, payload) {
  await api.put(`/Depoimentos/${id}`, payload);
}

export async function deleteDepoimento(id) {
  await api.delete(`/Depoimentos/${id}`);
}
